import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_2 = { class: "sr-only" }

import { PropType } from 'vue';
import { ConnectFlowFlowModel } from '@/types';
import { BookmarkIcon } from '@heroicons/vue/solid';
import ConnectFlowIcon from '@/components/svg/ConnectFlowIcon';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowHistoryItem',
  props: {
    modelValue: {
        type: Object as PropType<ConnectFlowFlowModel>,
        required: true,
    },
    published: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_UiAuditInfo = _resolveComponent("UiAuditInfo")!
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "flex items-center justify-between hover:bg-white" }, {
    default: _withCtx(() => [
      _createVNode(_component_UiAuditInfo, {
        "model-value": __props.modelValue,
        "date-format": "LLL"
      }, null, 8, ["model-value"]),
      (__props.published)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(BookmarkIcon), { class: "text-primary h-6 w-6" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('connectFlow.labels.published')), 1)
          ]))
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
        variant: "primary",
        to: {
                name: 'EditFlowHistoryById',
                params: {
                    id: __props.modelValue.connectFlowId,
                    historyId: __props.modelValue.id,
                },
            }
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('connectFlow.actions.editFlow')), 1),
          _createVNode(_unref(ConnectFlowIcon), {
            class: "h-6 w-6",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      }, 8, ["to"])), [
        [_directive_tippy, _ctx.$t('connectFlow.actions.editFlow')]
      ])
    ]),
    _: 1
  }))
}
}

})